/* DillySocks — Promo-Balken (Lauftext).

   Sorgt für einen NAHTLOSEN, längenunabhängigen Marquee:
   1. füllt die erste Gruppe mit Klonen, bis sie mindestens die Balkenbreite
      erreicht (sonst entstünde beim Loop eine Lücke),
   2. dupliziert die Gruppe (2 identische Hälften) — die CSS-Animation schiebt
      um genau eine Gruppenbreite (-50%) -> nahtlos,
   3. setzt die Animationsdauer aus Gruppenbreite / gewünschter Geschwindigkeit
      (px/s), damit die Geschwindigkeit unabhängig von der Textlänge ist.

   Reagiert auf Resize (debounced) und auf das Theme-Editor-Event
   shopify:section:load. */
(function () {
  'use strict';

  function build(bar) {
    var marquee = bar.querySelector('[data-ds-pb-marquee]');
    if (!marquee) return; // statischer Modus
    var viewport = bar.querySelector('.ds-promobar__viewport');
    var speed = parseFloat(bar.getAttribute('data-speed')) || 60;

    // Ursprungs-Template merken (einmalig), damit Rebuilds sauber sind.
    if (!bar._pbTemplate) {
      var first = marquee.querySelector('[data-ds-pb-group]');
      bar._pbTemplate = first ? first.innerHTML : '';
    }

    // Zurücksetzen: nur eine Gruppe mit dem Original-Inhalt.
    marquee.innerHTML = '';
    var group = document.createElement('div');
    group.className = 'ds-promobar__group';
    group.setAttribute('data-ds-pb-group', '');
    group.innerHTML = bar._pbTemplate;
    marquee.appendChild(group);

    if (!bar._pbTemplate.trim()) return;

    // Erste Gruppe füllen, bis sie den Viewport überdeckt.
    var originals = Array.prototype.slice.call(group.children);
    var guard = 0;
    while (group.scrollWidth < viewport.clientWidth && guard < 300) {
      originals.forEach(function (n) { group.appendChild(n.cloneNode(true)); });
      guard++;
    }

    // Zweite, identische Gruppe für den nahtlosen Loop.
    marquee.appendChild(group.cloneNode(true));

    // Dauer = zurückgelegte Distanz (eine Gruppenbreite) / Geschwindigkeit.
    var w = group.scrollWidth;
    var dur = w > 0 ? w / speed : 24;
    bar.style.setProperty('--ds-pb-dur', dur.toFixed(2) + 's');
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ds-promobar--marquee').forEach(build);
  }

  var t;
  function onResize() {
    clearTimeout(t);
    t = setTimeout(function () { initAll(document); }, 200);
  }

  function start() {
    initAll(document);
    window.addEventListener('resize', onResize);
    // Theme-Editor: Section neu geladen / bearbeitet.
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
